import { render } from "./SwipeButton.vue?vue&type=template&id=47a23b9c&scoped=true"
import script from "./SwipeButton.vue?vue&type=script&lang=js"
export * from "./SwipeButton.vue?vue&type=script&lang=js"

import "./SwipeButton.vue?vue&type=style&index=0&id=47a23b9c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a23b9c"]])

export default __exports__